import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FocusModuleWindow } from './FocusModuleWindow/FocusModuleWindow';
export const DynamicBackground = ({ children, }) => {
    const [activeSection, setActiveSection] = useState(null);
    const sectionMap = useRef(new Map());
    const registerSection = (node, metadata) => {
        if (node && !sectionMap.current.has(node)) {
            sectionMap.current.set(node, metadata);
            if (!activeSection && sectionMap.current.size === 1) {
                setActiveSection(metadata);
            }
        }
    };
    const handleActiveSectionChange = (activeNode) => {
        const metadata = sectionMap.current.get(activeNode);
        if (metadata) {
            setActiveSection(metadata);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                zIndex: -1,
                overflow: 'hidden',
            } }, activeSection && (React.createElement(AnimatePresence, { initial: false, mode: "popLayout" },
            React.createElement(motion.div, { key: `${activeSection.backgroundColor}-${activeSection.gradientBottomColor}-${activeSection.textColor}`, initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, transition: { duration: 0.5, ease: 'easeInOut' }, style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: activeSection.backgroundColor &&
                        activeSection.gradientBottomColor
                        ? `linear-gradient(180deg, ${activeSection.backgroundColor}, ${activeSection.gradientBottomColor})`
                        : activeSection.textColor || 'transparent',
                } })))),
        React.createElement(FocusModuleWindow, { refs: Array.from(sectionMap.current.keys()), onFocusModuleChange: handleActiveSectionChange },
            React.createElement("div", null, children(registerSection)))));
};
